import React from 'react';
import { MobileProps, SearchType } from '../../../../types';
import styled from 'styled-components';
import { leftBorder } from '../../../../styles';
import DurationTripField from './components/DurationTripField';
import { fieldParams } from './constants';
import { rightArrowSymbol } from '../../constants';

type DurationTripProps = {
  leftValue: string;
  rightValue: string;
  openCalendar: () => void;
  monthMode?: boolean;
  searchType: SearchType;
  isOpenCalendar?: boolean;
  onStartDateClick?: React.MouseEventHandler<HTMLDivElement>;
  onEndDateClick?: React.MouseEventHandler<HTMLDivElement>;
  isStartDateFocus: boolean;
  isEndDateFocus: boolean;
  variant?: 'default' | 'hotel';
} & MobileProps;

export const DurationTrip = ({
  leftValue,
  rightValue,
  monthMode,
  isMobile,
  isWizard,
  searchType,
  isOpenCalendar = false,
  onStartDateClick,
  onEndDateClick,
  isStartDateFocus,
  isEndDateFocus,
  variant = 'default',
}: DurationTripProps) => {
  const [leftParams, rightParams] = monthMode ? fieldParams.month : fieldParams.days;
  const color = isMobile ? '#c2c5cc' : '#919499';
  return (
    <DurationTripFieldContainer
      $isWizard={isWizard}
      $isMobile={isMobile}
      $color={color}
      $active={!!(leftValue && rightValue)}
      $variant={variant}
    >
      <DurationTripField
        onClick={onStartDateClick}
        value={leftValue}
        isMobile={isMobile}
        isWizard={isWizard}
        searchType={searchType}
        isActive={isOpenCalendar && isStartDateFocus}
        placeholderText={isOpenCalendar && !leftValue && isStartDateFocus ? '...' : undefined}
        variant={variant}
        {...leftParams}
      />
      {isWizard && <SplitArrowContainer>{rightArrowSymbol}</SplitArrowContainer>}
      <DurationTripFieldBack
        onClick={onEndDateClick}
        value={rightValue}
        isMobile={isMobile}
        isWizard={isWizard}
        searchType={searchType}
        isActive={isOpenCalendar && isEndDateFocus}
        placeholderText={isOpenCalendar && !rightValue && isEndDateFocus ? '...' : undefined}
        $leftValue={!!leftValue && !rightValue}
        variant={variant}
        {...rightParams}
      />
    </DurationTripFieldContainer>
  );
};

const DurationTripFieldContainer = styled.div<{
  $isMobile?: boolean;
  $isWizard?: boolean;
  $color: string;
  $active: boolean;
  $variant?: string;
}>`
  display: inline-flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  gap: ${({ $isMobile, $isWizard }) => ($isMobile && !$isWizard ? '8px' : '0')};
  color: ${({ $active, $color }) => ($active ? '#17181A' : $color)};
  position: relative;
  ${({ $isMobile, $variant }) => !$isMobile && $variant !== 'hotel' && leftBorder}
  ${({ $isMobile }) => $isMobile && `width: 100%`}
`;

const SplitArrowContainer = styled.span`
  font-family: cursive;
  color: inherit;
`;

const DurationTripFieldBack = styled(DurationTripField)<{
  $leftValue: boolean;
}>`
  ${({ $leftValue }) => $leftValue && 'z-index: 99; cursor: default'}
`;
